module.exports = __webpack_public_path__ + "static/assets/60d46902ec6c55f7896dee4cb2e0ef32.png";